import React from "react";
import moment from "moment";
import _ from 'lodash';

const DeadLineCard = ({ children }) => {
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];

  const date = moment(children).format("DD");
  const day = moment(children).format("MMMM");
  const year = moment(children).format("YYYY");

  return (
    <div
      className={`flex items-center justify-between w-max text-mute-grey `}
    >
      <span className={`text-md  mr-2 font-semibold text-deep-grey`}> Dead Line : </span>
      <span className="mr-1 text-md font-medium">{date}</span>{" "}
      <span className="mr-1 text-md font-medium">{_.capitalize(day.slice(0, 3)) }</span>{" "}
      <span className="text-md font-medium">{year}</span>
    </div>
  );
};

export default DeadLineCard;
